export const ROLES = {
    ADMIN: "ADMIN",
    DELIVERY_AGENT: "DELIVERY_AGENT",
    SUPER_AGENT: "SUPER_AGENT",
    DELIVERY_MANAGEMENT: "DELIVERY_MANAGEMENT",
    STORE_MANAGEMENT: "STORE_MANAGEMENT",
    INVENTORY_MANAGEMENT: "INVENTORY_MANAGEMENT",
    ACCOUNTS : "ACCOUNTS",
    ACCOUNTS_ADMIN: "ACCOUNTS_ADMIN",
    MANAGEMENT: "MANAGEMENT",
    STORE_INCHARGE: "STORE_INCHARGE"
}